/**
 * React Day Picker uses CSS classnames for styling.
 * Most style / functionality overrides are being provided as custom components instead.
 * See: nucleus-components/packages/date-picker/src/lib/calendar-components.tsx
 */
export const calendarStyles = {
    months: 'nucleus-flex',
};
//# sourceMappingURL=calendar_styles.js.map